/** Free-tier preview limits (subscribers see full data). */
export const PREVIEW_TRADE_FLASH_ROWS = 3;

/** Default when API does not send delay_minutes (matches backend MARKET_DATA_DELAY_MINUTES). */
export const MARKET_DATA_DELAY_MINUTES = 15;

export const TIME_SALES_COLUMN_KEYS = [
  "time",
  "option",
  "qty",
  "price",
  "exchange",
  "market",
  "delta",
  "iv",
  "underlying",
  "condition",
];
